





































































































































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@/utils/common";
import { Table } from "@/utils/decorator";
import DataImport from "@/components/scope/data-import.vue";

import dayjs from "dayjs";
const service = namespace("service");
const base = namespace("base");
const staff = namespace("staff");
const setting = namespace("setting");
const inventory = namespace("inventory");
const typeMap: any = {
  maintenance: 1,
  wash: 2,
  retail: 3
};
@Component({
  components: { DataImport }
})
@Table("loadListData")
@Table.DataImport({
  templateUrl: "https://static.gtech.asia/static/template/speedbiz/入库单导入.xlsx",
  actionUrl: "/filecloud/importInbounds"
})
export default class ServiceList extends Vue {
  dayjs = dayjs;
  @base.Action getDictionaryList;
  @staff.Action getStaffList;
  @inventory.Action inWarehouseComplete;
  @inventory.Action getInWarehouseList;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  orderList: any[] = [];
  searchForm = {
    inboundType: "",
    inboundUser: "",
    startInboundDate: "",
    endInboundDate: "",
    inboundStatus: "",
    customerPlateCode: "",
    orderNo: ""
  };
  orderStatusList: any[] = [];
  orderTypeList: any[] = [];
  staffList: any[] = [];
  defaultExpend: boolean = false;
  created() {
    this.init();
    this.loadListData();
  }
  init() {
    // 订单状态字典List
    this.getDictionaryList("inbound_status").then(data => {
      this.orderStatusList = data;
    });
    // 订单类型字典List
    this.getDictionaryList("inbound_type").then(data => {
      this.orderTypeList = data;
    });
    // 员工和顾问 List
    this.getStaffList({
      pageSize: 999,
      pageNum: 1
    }).then(data => {
      const staffList =
        data.data.list &&
        data.data.list.map(item => ({
          label: item.staffName,
          value: item.userCode
        }));
      this.staffList = staffList;
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getInWarehouseList({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = data.data.list;
      return data;
    });
  }
  handleSwitchStatus(tab) {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  handleComplete(row) {
    this.inWarehouseComplete({
      inboundNo: row.inboundNo
    }).then(data => {
      this.$message.success(this.$t("warehouse.inbound-success") as string);
      this.loadListData();
    });
  }
  get searchList() {
    return [
      {
        label: "warehouse.inbound-type",
        type: "select",
        selectList: this.orderTypeList,
        value: "",
        prop: "inboundType"
      },
      {
        label: "warehouse.inbound-people",
        type: "select",
        selectList: this.staffList,
        value: "",
        prop: "inboundUser"
      },
      {
        label: "warehouse.inbound-date",
        type: "daterange",
        value: "",
        prop: "startInboundDate"
      },
      {
        label: "base.order-status",
        type: "select",
        selectList: this.orderStatusList,
        value: "",
        prop: "inboundStatus"
      },
      {
        label: "other.relation-vehicle",
        type: "input",
        value: "",
        prop: "customerPlateCode"
      },
      {
        label: "other.relation-service-order",
        type: "input",
        value: "",
        prop: "orderNo"
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "startInboundDate") {
          this.searchForm["startInboundDate"] = item.value ? item.value[0] : "";
          this.searchForm["endInboundDate"] = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  handleEdit(row) {
    this.$router.push(`/inventory/in-warehouse-edit/${row.inboundNo}`);
  }
  handleLinkOrderView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/inventory/in-warehouse-view/${row.inboundNo}`
    });
    window.open(href, "_blank");
  }
}
